export default __webpack_public_path__ + "static/media/favicon.b8d2c6fb.ico";